module.exports = __webpack_public_path__ + "assets/img/face_crux_scene1.a7aea807.png";